/**
 * A helper class for async operations.
 */
export class AsyncHelper {
    public static sleep(milliseconds: number): Promise<void> {
        return new Promise((accept: () => void) => setTimeout(accept, milliseconds));
    }
}
